import type { RespAppRightsVersion } from '@vas2t-lowcode/api';
/** 获取配置 */
export const useWAppRights = () => {
  /** 判断是否应用到期，包含试用期到期和购买（平台、应用）后到期 */
  const isAppOutOfDate = (rightsData: RespAppRightsVersion) => {
    if (!rightsData) {
      return;
    }

    return rightsData.is_end_time_expired;
  };

  /** 是否单购有效期内 */
  const isSinglePayValid = (rightsData: RespAppRightsVersion) => {
    if (!rightsData) {
      return;
    }

    const { is_app_single_purchase } = rightsData;

    return is_app_single_purchase && !isAppOutOfDate(rightsData);
  };

  /** 是否试用有效期内 */
  const isPayTrailValid = (rightsData: RespAppRightsVersion) => {
    if (!rightsData) {
      return;
    }

    const { is_trial_expired } = rightsData.app_paid_ver || {};

    return rightsData.is_trial && !is_trial_expired;
  };

  /** 平台付费期 */
  const isPayPlatformValid = (rightsData: RespAppRightsVersion) => {
    if (!rightsData) {
      return;
    }

    const { is_paid_effective, member_id } = rightsData.team_paid_ver || {};

    return is_paid_effective && member_id! > 0;
  };

  return {
    isAppOutOfDate,
    isSinglePayValid,
    isPayTrailValid,
    isPayPlatformValid,
  };
};
